/**
 * 防止短时间内重复点击。
 */
var dbClick = {
  inserted: function inserted(el) {
    el.addEventListener('click', function () {
      if (!el.disabled) {
        el.disabled = true;
        el.style.cursor = 'not-allowed';
        setTimeout(function () {
          el.style.cursor = 'pointer';
          el.disabled = false;
        }, 1000);
      }
    });
  }
};
export default dbClick;